import { fontWeight } from "@mui/system";
import React, { useEffect, useState, useRef, useMemo } from "react";


function PurchaseReceivedPDF({ orderDetails, productList }) {

    const totals = productList.reduce(
        (acc, item) => {
            const qty = Number(item?.quantity) || 0;
            const rate = Number(item?.rate) || 0;
            const discount = Number(item?.discount) || 0;
            const itemTotal = qty * rate - discount;
            const totalGst = Number(item.orderTotalWithGst) || 0

            acc.totalQuantity += qty;
            acc.subTotal += qty * rate;
            acc.totalDiscount += discount;
            acc.total += itemTotal;
            acc.totalWithGst += totalGst;

            return acc;
        },
        { totalQuantity: 0, subTotal: 0, totalDiscount: 0, total: 0, totalWithGst: 0 }
    );

    // 👉 Now calculate GST separately based on subtotal
    const gstAmount = (totals.subTotal * 18) / 100;

    // 👉 Final total including GST
    const grandTotal = totals.total + gstAmount;


    return (
        <>
            <style>{`
         body {
            font-family: Arial, sans-serif;
            margin: 0;
            /* padding: 20px; */
            /* background: #f9f9f9; */
            
        }
        .container {
            background: #fff;
            margin: auto;
            padding: 20px 20px 50px 20px;
            font-size: 9px;
            letter-spacing: 1.5px;
            /* box-shadow: 0 0 10px rgba(0,0,0,0.1); */
        }

        .header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }
        .left{
            width: 50%;
        }
        .right{
            width: 50%;
        }
        .left p,
        .right p {
            margin: 4px 0;
            font-size: 10px;
        }

        .right h2 {
            margin: 0;
            font-size: 11px;
        }
        h2{
            font-size: 10px;
            font-weight:600;
        }

        .title {
            // text-align: right;
            margin: 20px 0;
            font-size: 15px;
            font-weight: bold;
            letter-spacing: 2px;
        }

        .title span {
            font-size: 16px;
            display: block;
        }
        .vendordata{
            font-size: 11px
        }    

        .vendor {
            margin-bottom: 20px;
            font-size: 11px
        }
        .vendordata h3{
            margin-bottom: 5px;
            font-size: 11px;
            font-weight:600;
            margin-top: 20px;
        }    

        .vendor h3 {
            margin-bottom: 5px;
            font-size: 11px;
            font-weight:600;
            margin-top: 20px;
        }

        .items {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
        }

        .items th,
        .items td {
            padding: 10px;
            text-align: left;
            vertical-align: top;
        }
        .items td{
            border-bottom:1px solid #ccc
        }

        .items th {
            background-color: #333;
            color: #fff;
        }

        .notes h3 {
            margin-bottom: 5px;
            font-size: 11px
        }
        .notes p{
                font-size: 9px;
                text-align:center;
                margin-top: 20px;
        }
        .d-flex{
                display:flex;
                align-items:center;
                margin-top:5px;
        }
        .d-flex .label{
            width: 150px;    
        }
        .purchaseOrderDetails.pdffooter .subtotal{font-size:11px}
        .purchaseOrderDetails.pdffooter .discountsec .dishd{font-size:10px}
        .purchaseOrderDetails.pdffooter .subtotal.total{font-size: 13px;}
        .purchaseOrderDetails.pdffooter .font-xs.text-muted.qty{font-size: 10px; margin-top:10px}
        .vendor .labelwd{width:100px}


      `}</style>
            <div class="container">
                <div class="header">
                    <div class="left">
                        <h1 class="title">PURCHASE ORDER</h1>
                        {/* <h2>PTOLEMY TECHNOLOGY PRIVATE LIMITED (DAQI)</h2>
                        <p>Maharashtra<br />India<br />support@daqi.in</p> */}
                        <div class="vendordata">
                            <h3>Vendor Address:</h3>
                            <div>{orderDetails?.ShopNumberAndBuildingName}</div>
                            <div><span>{orderDetails?.address1}</span> {orderDetails?.city}</div>
                            <div><span>{orderDetails?.state}</span> {orderDetails?.shopPinCode}</div>
                        </div>
                        <div class="vendordata">
                            <div className="d-flex">
                                {/* <div className="labelwd"><strong>Name:</strong></div> */}
                                <div>{orderDetails?.vendorName && orderDetails.vendorName !== "NULL" ? orderDetails.vendorName : "-"}</div>
                            </div>
                            <div className="d-flex">
                                {/* <div className="labelwd"><strong>Shop Name:</strong> </div> */}
                                <div>{orderDetails?.vendorShopName && orderDetails.vendorShopName !== "NULL" ? orderDetails.vendorShopName : "-"}</div>
                            </div>
                            <div className="d-flex">
                                {/* <div className="labelwd"><strong>Mobile:</strong></div> */}
                                <div>{orderDetails?.vendorMobile && orderDetails.vendorMobile !== "NULL" ? orderDetails.vendorMobile : "-"}</div>
                            </div>
                            <div className="d-flex">
                                {/* <div className="labelwd"><strong>Email:</strong> </div> */}
                                <div>{orderDetails?.vendorEmail && orderDetails.vendorEmail !== "NULL" ? orderDetails.vendorEmail : "-"}</div>
                            </div>
                        </div>

                    </div>
                    <div class="right">
                        {/* <h1 class="title">PURCHASE ORDER</h1> */}
                        <p style={{ fontWeight: 600 }}>
                            Purchase Order: #{orderDetails?.purchaseOrder}
                        </p>
                        <p>
                            Date: {orderDetails?.date}
                        </p>
                        <div class="vendordata">
                            <h3>Delivery Address:</h3>
                            <div>{orderDetails?.deliveryAddress}</div>
                        </div>
                        <div class="vendordata">
                            <div className="d-flex">
                                {/* <div className="labelwd"><strong>Name:</strong> </div> */}
                                <div>{orderDetails?.deliveryPersonName && orderDetails.deliveryPersonName !== "NULL" ? orderDetails.deliveryPersonName : "-"}</div>
                            </div>
                            <div className="d-flex">
                                {/* <div className="labelwd"><strong>Mobile:</strong> </div> */}
                                <div>{orderDetails?.deliverymobileNumber && orderDetails.deliverymobileNumber !== "NULL" ? orderDetails.deliverymobileNumber : "-"}</div>
                            </div>
                            <div className="d-flex">
                                {/* <div className="labelwd"><strong>Email:</strong></div> */}
                                <div>{orderDetails?.deliveryEmail && orderDetails.deliveryEmail !== "NULL" ? orderDetails.deliveryEmail : "-"}</div>
                            </div>
                        </div>
                        {/* <div style={{ marginTop: "20px" }}>
                            <p className="d-flex"><div className="label">Date :</div> <div>28/04/2025</div></p>
                            <p className="d-flex"><div className="label">Status :</div> <div>Received</div></p>
                        </div> */}

                    </div>
                </div>

                <table class="items">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item & Description</th>
                            <th>Color</th>
                            <th>Qty</th>
                            <th>Rate</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            productList.map((item, index) => {
                                return <tr>

                                    <td>{index + 1}</td>
                                    <td>{item?.productName}</td>
                                    <td>{item?.color ?? ""}</td>
                                    <td>{item.quantity} Nos</td>
                                    <td>{item?.rate != null ? Number(item.rate).toFixed(2) : "0.00"}</td>
                                    <td>{item?.amount != null ? Number(item.amount).toFixed(2) : "0.00"}</td>
                                </tr>
                            })
                        }


                    </tbody>
                </table>
                <div className="purchaseOrderDetails pdffooter">
                    <div className="rtsec">
                        <div className="group mt-5">
                            <div className="row">
                                <div className="col-lg-6 col-md-9 ms-auto sub-total-section">
                                    <div className="">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <strong className="subtotal">Sub Total</strong>
                                                <div className="font-xs text-muted qty">Total Quantity : {totals.totalQuantity}</div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 over-flow">
                                                <strong className="subtotal">Rs.{orderDetails?.orderTotal != null ? Number(orderDetails.orderTotal).toFixed(2) : "0.00"}</strong>
                                            </div>
                                        </div>

                                        <div className="row text-muted discountsec">
                                            <div className="col-lg-6 col-md-6">
                                                <span className="dishd">GST (18%)</span>
                                            </div>
                                            <div className="col-lg-6 col-md-6 over-flow">
                                                <span className="dishd">Rs.{orderDetails?.gstAmount != null ? Number(orderDetails.gstAmount).toFixed(2) : "0.00"}</span>
                                            </div>
                                        </div>

                                        <div className="row text-muted discountsec">
                                            <div className="col-lg-6 col-md-6">
                                                <span className="dishd">Discount</span>
                                            </div>
                                            <div className="col-lg-6 col-md-6 over-flow">
                                                <span className="dishd">Rs.{orderDetails?.discountAmount != null ? Number(orderDetails.discountAmount).toFixed(2) : "0.00"}</span>
                                            </div>
                                        </div>


                                        <div className="row text-muted discountsec">
                                            <div className="col-lg-6 col-md-6">
                                                <span className="dishd">Adjustment</span>
                                            </div>
                                            <div className="col-lg-6 col-md-6 over-flow">
                                                <span className="dishd">Rs.{orderDetails?.adjustmentAmount != null ? Number(orderDetails.adjustmentAmount).toFixed(2) : "0.00"}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <strong className="subtotal total">Total</strong>
                                        </div>
                                        <div className="col-lg-6 col-md-6 over-flow">
                                            <strong className="subtotal">Rs.{orderDetails?.orderTotalWithDiscount != null ? Number(orderDetails.orderTotalWithDiscount).toFixed(2) : "0.00"}</strong>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <br />
                        </div>
                    </div>
                </div>

                <div class="notes">
                    <p>This purchase order has been generated by a computer and does not require a signature.</p>
                </div>
            </div>
        </>
    );
}

export default PurchaseReceivedPDF;
